class Reminders {

  constructor(basePath, apiClient) {

    this.basePath = `${basePath}/:activityId/reminders`;
    this.apiClient = apiClient;

  }

  async setupReminder(activityId, data) {

    const path = `${this.basePath}`;

    return this.apiClient.post(path, { activityId }, {}, data);

  }

  async updateReminderById(activityId, reminderId, data) {

    const path = `${this.basePath}/:reminderId`;

    return this.apiClient.put(path, { activityId, reminderId }, {}, data);

  }

  async deleteReminderById(activityId, reminderId) {

    const path = `${this.basePath}/:reminderId`;

    return this.apiClient.delete(path, { activityId, reminderId }, {});

  }

}

export default Reminders;